import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as organization from '../../../../organization'
import * as previousOccupier from '../previous-occupier'

export const RESOURCE = {
  payload: {
    canBeOptional: false,
    context: core.dms.models.Attribute.Id.Context.from({
      context: previousOccupier.RESOURCE.payload.dimension.partialId,
      partialId: previousOccupier.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Snapshot,
    }),
    description:
      'Organizational unit the space record previously had as its occupier',
    isOptional: false,
    name: 'Previous Occupier',
    partialId: PartialId.Standard.create('previous_occupier'),
    type: {
      dimensionId: core.dms.models.Dimension.Id.from(
        organization.RESOURCE.payload,
      ),
    },
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
